import { FunctionComponent } from 'react';
import Search from '../Components/Search';

import render from '../utils/render';

render('.combined-search', Search as FunctionComponent, true);
